import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const scrollToForm = () => {
    document.getElementById('lead-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-32 bg-brand-dark relative overflow-hidden border-t border-brand-border" data-id="element-90">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-92">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-light text-white mb-8 leading-tight tracking-tight" data-id="element-93">
            Ready to join the Lima Dental VIP Plan?
          </h2>
          <p className="text-xl text-brand-muted font-light mb-12 max-w-2xl mx-auto" data-id="element-94">
            $500/year — Affordable, premium dental care for you and your family.
            No insurance needed.
          </p>

          <button onClick={scrollToForm} className="bg-white hover:bg-white/90 text-brand-dark font-medium py-4 px-12 rounded-full transition-all text-lg" data-id="element-95">
            Join the VIP Plan Today
          </button>
        </motion.div>
      </div>
    </section>;
}